/**
 * @class HelperConfiguration
 */
export default class HelperConfiguration {
    /**
     * @param {Boolean}     autoCheck
     * @param {Boolean}     autoDownload
     * @param {Boolean}     autoForceInstall
     * @param {Boolean}     autoInstall
     * @param {Number}      autoInstallDelay
     * @param {Boolean}     autoInstallNewDatabases
     * @param {Boolean}     autoNightCheck
     * @param {Number}      autoNightCheckInterval
     * @param {String}      autoNightCheckStart
     * @param {String}      autoNightCheckEnd
     * @param {Number}      autoInterval
     * @param {Boolean}     autoRebootDelay
     * @param {Number}      serverPort
     * @param {String}      webHost
     * @param {Number}      webPort
     */
    constructor(
        autoCheck,
        autoDownload,
        autoForceInstall,
        autoInstall,
        autoInstallDelay,
        autoInstallNewDatabases,
        autoNightCheck,
        autoNightCheckInterval,
        autoNightCheckStart,
        autoNightCheckEnd,
        autoInterval,
        autoRebootDelay,
        serverPort,
        webHost,
        webPort
    ) {
        this._autoCheck = autoCheck;
        this._autoDownload = autoDownload;
        this._autoForceInstall = autoForceInstall;
        this._autoInstall = autoInstall;
        this._autoInstallDelay = autoInstallDelay;
        this._autoInstallNewDatabases = autoInstallNewDatabases;
        this._autoNightCheck = autoNightCheck;
        this._autoNightCheckInterval = autoNightCheckInterval;
        this._autoNightCheckStart = autoNightCheckStart;
        this._autoNightCheckEnd = autoNightCheckEnd;
        this._autoInterval = autoInterval;
        this._autoRebootDelay = autoRebootDelay;
        this._serverPort = serverPort;
        this._webHost = webHost;
        this._webPort = webPort;
    }

    /**
     * @return {Boolean}
     */
    get autoCheck() {
        return this._autoCheck;
    }

    /**
     * @param {Boolean} autoCheck
     */
    set autoCheck(autoCheck) {
        this._autoCheck = autoCheck;
    }

    /**
     * @return {Boolean}
     */
    get autoDownload() {
        return this._autoDownload;
    }

    /**
     * @param {Boolean} autoDownload
     */
    set autoDownload(autoDownload) {
        this._autoDownload = autoDownload;
    }

    /**
     * @return {Boolean}
     */
    get autoInstall() {
        return this._autoInstall;
    }

    /**
     * @param {Boolean} autoInstall
     */
    set autoInstall(autoInstall) {
        this._autoInstall = autoInstall;
    }

    /**
     * @return {Boolean}
     */
    get autoForceInstall() {
        return this._autoForceInstall;
    }

    /**
     * @param {Boolean} autoForceInstall
     */
    set autoForceInstall(autoForceInstall) {
        this._autoForceInstall = autoForceInstall;
    }

    /**
     * @return {Number}
     */
    get autoInstallDelay() {
        return this._autoInstallDelay;
    }

    /**
     * @param {Number} autoInstallDelay
     */
    set autoInstallDelay(autoInstallDelay) {
        this._autoInstallDelay = autoInstallDelay;
    }

    /**
     * @return {Boolean}
     */
    get autoInstallNewDatabases() {
        return this._autoInstallNewDatabases;
    }

    /**
     * @param {Boolean} autoInstall
     */
    set autoInstallNewDatabases(autoInstallNewDatabases) {
        this._autoInstallNewDatabases = autoInstallNewDatabases;
    }

    /**
     * @return {Boolean}
     */
    get autoNightCheck() {
        return this._autoNightCheck;
    }

    /**
     * @param {Boolean} autoNightCheck
     */
    set autoNightCheck(autoNightCheck) {
        this._autoNightCheck = autoNightCheck;
    }

    /**
     * @return {Number}
     */
    get autoNightCheckInterval() {
        return this._autoNightCheckInterval;
    }

    /**
     * @param {Number} autoNightCheckStart
     */
    set autoNightCheckInterval(autoNightCheckInterval) {
        this._autoNightCheckInterval = autoNightCheckInterval;
    }

    /**
     * @return {String}
     */
    get autoNightCheckStart() {
        return this._autoNightCheckStart;
    }

    /**
     * @param {String} autoNightCheckStart
     */
    set autoNightCheckStart(autoNightCheckStart) {
        this._autoNightCheckStart = autoNightCheckStart;
    }

    /**
     * @return {String}
     */
    get autoNightCheckEnd() {
        return this._autoNightCheckEnd;
    }

    /**
     * @param {String} autoNightCheckEnd
     */
    set autoNightCheckEnd(autoNightCheckEnd) {
        this._autoNightCheckEnd = autoNightCheckEnd;
    }

    /**
     * @return {Number}
     */
    get autoInterval() {
        return this._autoInterval;
    }

    /**
     * @param {Number} autoInterval
     */
    set autoInterval(autoInterval) {
        this._autoInterval = autoInterval;
    }

    /**
     * @return {Boolean}
     */
    get autoRebootDelay() {
        return this._autoRebootDelay;
    }

    /**
     * @param {Boolean} autoRebootDelay
     */
    set autoRebootDelay(autoRebootDelay) {
        this._autoRebootDelay = autoRebootDelay;
    }

    /**
     * @return {Number}
     */
    get serverPort() {
        return this._serverPort;
    }

    /**
     * @param {Number} serverPort
     */
    set serverPort(serverPort) {
        this._serverPort = serverPort;
    }

    /**
     * @return {String}
     */
    get webHost() {
        return this._webHost;
    }

    /**
     * @param {String} webHost
     */
    set webHost(webHost) {
        this._webHost = webHost;
    }

    /**
     * @return {Number}
     */
    get webPort() {
        return this._webPort;
    }

    /**
     * @param {Number} webPort
     */
    set webPort(webPort) {
        this._webPort = webPort;
    }
}
